class ClientRegistrationConfirmUsersController {
  static controller($scope, $state) {
      'ngInject';
      $scope.userName = $state.params.userName;
  };
}

export default ClientRegistrationConfirmUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-registration-confirm.users.controller.js